module.exports = __webpack_public_path__ + "static/media/windmill.00adb298.jpg";